import type { PriceChangeRequestHistoryItem } from '../codegen/graphql';

export function getLastResolvedHistoryItem(
    items: PriceChangeRequestHistoryItem[],
): PriceChangeRequestHistoryItem | null {
    for (let i = items.length - 1; i >= 0; i -= 1) {
        const item = items[i];
        if (item.status !== 'Pending') {
            return item;
        }
    }
    return null;
}
